// @flow

import Roarr from 'roarr';

const Logger = Roarr
  .child({
    package: 'palantir'
  });

export default Logger;
